import OwnerEntityContainer from './OwnerEntityContainer';

export default OwnerEntityContainer;
